if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };

        this.hasCustomFields = !!document.querySelector(
          ".m-main-product--info .m-product-custom-field"
        );
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");

        if (!this.container || !this.mainProductForm) return;

        this.mainAddToCart =
          this.mainProductForm.querySelector(".m-add-to-cart");

        this.mainDynamicCheckout =
          this.mainProductForm.querySelector(this.selectors.buyNowBtn);

        this.productId = this.dataset.productId;

        this.selectedVariantDefault =
          this.dataset.disableSelectedVariantDefault === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = queryString.includes("?variant=");

        if (
          !hasQueryString &&
          this.selectedVariantDefault &&
          this.variantData &&
          this.variantData.length > 1
        ) {
          this.disableSelectedVariantDefault();
        }

        this.init();

        // Spinner riêng cho Sticky Add to Cart
        this.initStickyLoading();

        this.setStickyAddToCartHeight();

        this.addEventListener("change", () => {
          const variantSelect = this.querySelector(
            this.selectors.variantIdSelect
          );

          if (!variantSelect) return;

          const selectedVariantId = variantSelect.value;

          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(selectedVariantId)
          );

          this.updateButton(true, "", false);

          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(
              !this.currentVariant.available,
              window.MinimogStrings.soldOut
            );
          }
        });

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });

        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        const variantJson =
          this.container.querySelector('[type="application/json"]');

        if (!variantJson) return [];

        this.variantData =
          this.variantData || JSON.parse(variantJson.textContent);

        return this.variantData;
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        const {
          prodTitle,
          mainImage,
          addToCart,
          buyNowBtn,
          foxkitBtn,
        } = this.domNodes;

        if (buyNowBtn) {
          this.enable_dynamic_checkout = true;
        }

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty(
                    "--m-translate-y",
                    "100%"
                  );
                }

                document.documentElement.classList[
                  entry.intersectionRatio !== 1 ? "add" : "remove"
                ]("stick-atc-show");
              });
            },
            {
              threshold: 1,
              rootMargin,
            }
          );
        }

        if (prodTitle) {
          prodTitle.addEventListener("click", () => __scrollToTop());
        }

        if (mainImage) {
          mainImage.addEventListener("click", () => __scrollToTop());
        }

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;

          const customFields = document.querySelectorAll(
            ".m-main-product--info .m-product-custom-field"
          );

          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");

              if (
                field &&
                field.value == "" &&
                field.hasAttribute("required")
              ) {
                hasCustomFieldRequired = true;
              }
            });

          if (hasCustomFieldRequired && addToCart) {
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();

              this.stopStickyLoading();

              __scrollToTop(
                this.mainProductForm,
                () => this.mainAddToCart.click()
              );
            });
          }

          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);

                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();

                  __scrollToTop(
                    this.mainProductForm,
                    () => this.mainDynamicCheckout.click()
                  );
                }
              },
              true
            );
          }

          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();

              __scrollToTop(
                this.mainProductForm,
                () => this.mainAddToCart.click()
              );
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      /*
       * =====================================================
       * STICKY ADD TO CART SPINNER
       * Chỉ tác động tới Sticky Add to Cart
       * =====================================================
       */

      initStickyLoading() {
        const stickyButton = this.domNodes.addToCart;

        if (!stickyButton) return;

        this.createStickySpinnerStyles();

        let spinner =
          stickyButton.querySelector(".sticky-atc-custom-spinner");

        if (!spinner) {
          spinner = document.createElement("span");
          spinner.className = "sticky-atc-custom-spinner";
          spinner.setAttribute("aria-hidden", "true");

          stickyButton.appendChild(spinner);
        }

        this.stickyButton = stickyButton;
        this.stickySpinner = spinner;

        /*
         * Đây là cơ chế click của bản đã xoay được.
         * KHÔNG chặn event.
         */
        stickyButton.addEventListener("click", () => {
          this.startStickyLoading();

          clearTimeout(this.stickyLoadingTimer);

          /*
           * Fallback 5 giây:
           * tránh spinner bị quay mãi.
           */
          this.stickyLoadingTimer = setTimeout(() => {
            this.stopStickyLoading();
          }, 5000);
        });

        /*
         * Khi cart hoàn thành/thay đổi,
         * tắt spinner.
         */
        const cartEvents = [
          "cart:updated",
          "cart:refresh",
          "cart:change",
          "cart:added",
          "cart:build",
        ];

        cartEvents.forEach((eventName) => {
          document.addEventListener(eventName, () => {
            this.stopStickyLoading();
          });
        });
      }

      startStickyLoading() {
        if (!this.stickyButton) return;

        this.stickyButton.classList.add("sticky-atc-is-loading");

        this.stickyButton.setAttribute(
          "aria-busy",
          "true"
        );

        if (this.stickySpinner) {
          this.stickySpinner.style.display = "block";
        }
      }

      stopStickyLoading() {
        if (!this.stickyButton) return;

        clearTimeout(this.stickyLoadingTimer);

        this.stickyButton.classList.remove(
          "sticky-atc-is-loading"
        );

        this.stickyButton.removeAttribute("aria-busy");

        if (this.stickySpinner) {
          this.stickySpinner.style.display = "none";
        }
      }

      createStickySpinnerStyles() {
        if (
          document.getElementById(
            "sticky-atc-custom-spinner-styles"
          )
        ) {
          return;
        }

        const style = document.createElement("style");

        style.id = "sticky-atc-custom-spinner-styles";

        style.textContent = `
          .m-sticky-addtocart .m-add-to-cart {
            position: relative;
          }

          .m-sticky-addtocart
          .m-add-to-cart.sticky-atc-is-loading {
            pointer-events: none;
          }

          .m-sticky-addtocart
          .m-add-to-cart.sticky-atc-is-loading
          .m-add-to-cart--text {
            opacity: 0;
          }

          .m-sticky-addtocart
          .sticky-atc-custom-spinner {
            display: none;
            position: absolute;
            width: 20px;
            height: 20px;
            top: 50%;
            left: 50%;
            margin-top: -10px;
            margin-left: -10px;
            box-sizing: border-box;
            border: 2px solid currentColor;
            border-right-color: transparent;
            border-radius: 50%;
            pointer-events: none;
            animation: stickyAtcCustomSpin 0.65s linear infinite;
          }

          @keyframes stickyAtcCustomSpin {
            from {
              transform: rotate(0deg);
            }

            to {
              transform: rotate(360deg);
            }
          }
        `;

        document.head.appendChild(style);
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";

        document.documentElement.style.setProperty(
          "--f-sticky-atc-bar-height",
          sectionHeight
        );
      }

      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(
          ".m-product-option--dropdown-select"
        );

        if (!pickerSelects) return;

        pickerSelects.value = "";
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm =
          this.querySelector(".sticky-atc-form");

        if (!productForm) return;

        const addButton =
          productForm.querySelector('[name="add"]');

        const addButtonText =
          productForm.querySelector(
            '[name="add"] > .m-add-to-cart--text'
          );

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute(
            "disabled",
            "disabled"
          );

          if (text && addButtonText) {
            addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");

          if (addButtonText) {
            addButtonText.textContent =
              window.MinimogStrings.addToCart;
          }
        }
      }

      syncWithMainProductForm() {
        const variantInput =
          this.querySelector('[name="id"]');

        if (!variantInput) return;

        window.MinimogEvents.subscribe(
          `${this.productId}__VARIANT_CHANGE`,
          async (variant) => {
            if (variant) {
              variantInput.value = variant.id;
            }
          }
        );
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty(
          "--f-sticky-atc-bar-height",
          this.offsetHeight + "px"
        );

        window.MinimogSettings.stickyAddToCartHeight =
          this.offsetHeight;
      }
    }
  );
}